<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getLink('/group')">
            <i class="ksi ksi-group"></i>
            <span>{{ $t('lang.menu.group') }}</span>
        </a>
        <a :href="getLink('/compare')">
            <i class="ksi ksi-compare"></i>
            <span>{{ $t('lang.menu.site_compare') }}</span>
        </a>
        <a :href="getLink('/tools/domains-batch')">
            <i class="ksi ksi-tools-domains-batch"></i>
            <span>{{ $t('lang.menu.tools_domains_batch') }}</span>
        </a>
        <a :href="getLink('/tools/concurents-by-keywords')">
            <i class="ksi ksi-tools-concurents-by-keywords"></i>
            <span>{{ $t('lang.menu.tools_concurents_by_keywords') }}</span>
        </a>
        <a :href="getLink('/tools/site-themes')">
            <i class="ksi ksi-tools-site-themes"></i>
            <span>{{ $t('lang.menu.tools_site_themes') }}</span>
        </a>
        <a :href="getLink('/tools/keywords-by-pages')">
            <i class="ksi ksi-tools-keywords-by-pages"></i>
            <span>{{ $t('lang.menu.tools_keywords_by_pages') }}</span>
        </a>
        <a :href="getLink('/tools/dictionary-ext-by-page')">
            <i class="ksi ksi-tools-dictionary-ext-by-page"></i>
            <span>{{ $t('lang.menu.tools_dictionary_ext_by_page') }}</span>
        </a>
        <a :href="getLink('/tools/dictionary-by-pages')">
            <i class="ksi ksi-tools-dictionary-by-pages"></i>
            <span>{{ $t('lang.menu.tools_dictionary_by_pages') }}</span>
        </a>
        <a :href="getLink('/robots')">
            <i class="ksi ksi-robots"></i>
            <span>{{ $t('lang.menu.robots') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";

export default {
    name: "MenuSubmenuTopSites",
    data() {
        return {
            listenerId: Listeners.TOP_MENU_TOP_SITES_HOVER,
        };
    },
    methods: {
        getLink(url) {
            return sprintf('/%s%s', window.locale, url);
        },
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>
